import { FETCH_NETWORK_DEVICE_VERSIONS } from "fleet/redux-store/ui-state/network-device-versions/actions";
import { EditNetworkPage } from "fleet/view/network/edit";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { getAuthUser } from "redux-store/auth/selectors";
import { EDIT_NETWORK } from "redux-store/networks/actions";
import { networksSelector } from "redux-store/networks/selectors";
import { isReadonly } from "redux-store/users/selectors";
import { storesReady } from "redux-store/utils";

function mapStateToProps(state, props) {
  const { id } = props.match.params || {};

  const storesLoaded = storesReady(state.global.networks);
  const networks = networksSelector(state);
  const network = networks[id];
  const user = getAuthUser(state);
  const readonly = isReadonly(user);

  return {
    network,
    readonly,
    storesLoaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchNetworkDeviceVersions: (networkId) => {
      return createPromiseApiAction(dispatch, FETCH_NETWORK_DEVICE_VERSIONS, [
        networkId,
      ]);
    },
    updateNetworkDetails: (serviceArgs) => {
      return createPromiseApiAction(dispatch, EDIT_NETWORK, [
        serviceArgs.networkId,
        serviceArgs.networkDetails,
      ]);
    },
  };
}

const ConnectedEditNetworkPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditNetworkPage);

export { ConnectedEditNetworkPage };
